import React from 'react';

const AboutUs = () => {
  return (
    <div className="min-h-screen text-black bg-white px-4 py-16 max-w-4xl mx-auto">
      <h1 className="text-4xl md:text-5xl text-center font-bold mb-16">
        ABOUT US
      </h1>

      {/* Main Description */}
      <div className="mb-16 text-gray-700 leading-relaxed">
        <p>
          Welcome to Elza2, your premier destination for lifestyle products in Egypt! 
          In 2022 we set out to create a lifestyle brand that embodies the fun, the trendy, 
          the loud and the crazy. We called it, Elza2. With our famous Slogan "هتغير مودك"
        </p>
      </div>

      {/* Our Mission */}
      <div className="mb-16">
        <h2 className="text-2xl font-bold text-black mb-6">Our Mission</h2>
        <p className="text-gray-700 leading-relaxed">
          Because we knew that the simplest everyday products have the power to add joy to people's lives. 
          We are dedicated to delivering exceptional products with a focus on quality, uniqueness, and 
          meticulous design that ensures our products stand out wherever they are showcased.
        </p>
      </div>

      {/* Why Choose Us */}
      <div className="mb-16">
        <h2 className="text-2xl font-bold text-black mb-6">Why Choose Elza2?</h2>
        <div className="space-y-8">
          <div>
            <h3 className="font-bold text-black mb-2">CREATIVITY</h3>
            <p className="text-gray-700">We celebrate creativity in all its forms, from the designs of our products to the stories they help our customers tell.</p>
          </div>
          
          <div>
            <h3 className="font-bold text-black mb-2">QUALITY</h3>
            <p className="text-gray-700">We are dedicated to sourcing and creating products of the highest quality, ensuring that every purchase exceeds expectations.</p>
          </div>
          
          <div>
            <h3 className="font-bold text-black mb-2">CUSTOMER SATISFACTION</h3>
            <p className="text-gray-700">Our customers are at the heart of everything we do. We are committed to providing exceptional service.</p>
          </div>
        </div>
      </div>

      {/* Policies Section */}
      <div className="mb-16">
        <h2 className="text-2xl font-bold text-black mb-6">Our Policies</h2>
        <div className="text-gray-700 space-y-4">
          <p>• Closed orders are received from the Courier.</p>
          <p>• There's no refund or Exchange because Our products are custom made.</p>
          <p>• In case of a defect in the product or an error in the order, replacement is made within 48 hours without incurring any additional costs.</p>
        </div>
      </div>

      {/* FAQs */}
      <div>
        <h2 className="text-2xl font-bold text-black mb-6">Frequently Asked Questions</h2>
        <div className="space-y-6 text-gray-700">
          <div>
            <p className="font-medium text-black mb-2">HOW LONG DOES DELIVERY TAKE?</p>
            <p className="text-gray-600">Your order should arrive between (5-7 business days)</p>
          </div>
          
          <div>
            <p className="font-medium text-black mb-2">HOW CAN I TRACK MY ORDER?</p>
            <p className="text-gray-600">You can track your order status by calling / Texting us: 01090400554. Also you'll receive a message confirmation once you've placed your order.</p>
          </div>
          
          <div>
            <p className="font-medium text-black  mb-2">HOW DO I PLACE AN ORDER?</p>
            <p className="text-gray-600">Placing an order takes a few minutes on our website. Simply pick your favorite product from our shop, click "add to cart" and then on the next page press "proceed to checkout". Now fill in your personal information and address details then click "Place Order".</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;